import { Transition } from "@headlessui/react";
import { useState } from "react";

const TooltipWrapper = ({
  className,
  name,
  children,
}: {
  className: string;
  name: string;
  children: React.ReactNode;
}) => {
  const [tooltipState, setTooltipState] = useState<boolean>(false);
  return (
    <div>
      <span
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        onMouseOver={() => setTooltipState(true)}
        onMouseLeave={() => setTooltipState(false)}
      >
        <button
          tabIndex={0}
          type="button"
          onClick={() => setTooltipState(false)}
        >
          {children}
        </button>
      </span>
      <Transition
        show={tooltipState}
        enter="ease-out duration-300"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <div
          className={`absolute bg-heading/80 
          rounded text-xs text-white font-semibold text-center px-4 py-1   z-50 ${className}`}
        >
          <p>{name}</p>
        </div>
      </Transition>
    </div>
  );
};

export default TooltipWrapper;
